import React from 'react';
import Box from '@mui/material/Box';
import { getStatusStyle } from './restaurantDeliveryOrderHelpers';

export function StatusBadge({ status, label: labelProp, bg: bgProp, color: colorProp }) {
  const fallback = getStatusStyle(status);
  const bg = bgProp ?? fallback.bg;
  const color = colorProp ?? fallback.color;
  const label =
    labelProp ??
    String(status || '—')
      .replace(/_/g, ' ')
      .replace(/\b\w/g, (c) => c.toUpperCase());
  return (
    <Box
      component='span'
      sx={{
        display: 'inline-block',
        bgcolor: bg,
        color,
        borderRadius: '20px',
        px: 1.25,
        py: 0.35,
        fontSize: 11.5,
        fontFamily: 'Inter Bold, sans-serif',
        fontWeight: 600,
        whiteSpace: 'nowrap',
      }}
    >
      {label}
    </Box>
  );
}
